import axiosInstance from './AxiosInstance'; // Reuse the centralized Axios instance

const DepartmentsService = {
  fetchDepartments: async (page, pageSize, sortBy, order,searchTerm) => {
    const queryObj = { 
      page, 
      pageSize,
      sortBy,
      order,
      searchTerm: searchTerm?.trim() || "", // Add searchTerm in the query object
    };
    try {
      const response = await axiosInstance.get('/department', {
        params: queryObj, // Query parameters
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching Departmentss:', error);
      throw error;
    }
  },

  createDepartments: async (data) => {
    try {
      const response = await axiosInstance.post('/serviceLevel', data);
      console.log("response.data------------", response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating Departments:', error);
      throw error;
    }
  },

  updateDepartments: async (id, data) => {
    try {
      const response = await axiosInstance.put(`/serviceLevel/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating Departments with ID ${id}:`, error);
      throw error;
    }
  },

  deleteDepartments: async (id) => {
    try {
      const response = await axiosInstance.delete(`/serviceLevel/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting Departments with ID ${id}:`, error);
      throw error;
    }
  },
};

export default DepartmentsService;
